import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import { useDescribeError } from '../i18n/useDescribeError';

/**
 * Toasts a failure. A recognised error code is said in the reader's language; anything else keeps
 * the ProblemDetails `detail` the API wrote — a 409 on a file in use, for instance, names the file
 * and explains itself far better than any message this app could invent.
 */
export function useErrorToast(): (error: unknown) => void {
  const { enqueueSnackbar } = useSnackbar();
  const describe = useDescribeError();

  return useCallback(
    (error: unknown) => {
      enqueueSnackbar(describe(error), { variant: 'error' });
    },
    [enqueueSnackbar, describe],
  );
}

export function useSuccessToast(): (message: string) => void {
  const { enqueueSnackbar } = useSnackbar();

  return useCallback(
    (message: string) => {
      enqueueSnackbar(message, { variant: 'success' });
    },
    [enqueueSnackbar],
  );
}
